<template>
  <div id="app" :class="menu == 1 ? 'indexApp' : menu == 3 ? 'eventApp' : '' ">
    <layout-vue @getKey="getKey"></layout-vue>
    <router-view @controlShow="controlShow" />
    <contactusVue></contactusVue>
  </div>
</template>

<script>
import LayoutVue from "./components/Layout.vue";
import ContactusVue from "./components/Contactus.vue";
export default {
  name: 'App',
  components:{
    LayoutVue,
    ContactusVue
  },
  data(){
    return{
      control:true,
      menu:'',
    }
  },
  created(){
  },
  methods:{
    controlShow(key){
      this.control = key;
    },
    getKey(e){
      this.menu = e;
    }
  }
}
</script>

<style lang="less">
html,
body,
#app {
  height: auto;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin: 0;
  padding: 0;
  .floatWindow{
    width: 100%;
    min-width: 1130px;
    margin: 0 auto;
    font-size: 13px;
    text-align: center;
    padding: 8px 0px;
    color: #ff9b1c;
    background-color: rgba(240, 215, 132, 0.4);
    img{
      cursor: pointer;
    }
  }
}
.indexApp{
  background: url('../static/index/background.png') no-repeat;
  background-size: 100% 100%;
}
.eventApp{
  background: url('../static/details/background.png') no-repeat;
  background-size: 100% 100%;
}
@media screen and (max-width: 500px) {
  .indexApp{
    background: url('../static/wap/index/background.png') no-repeat;
    background-size: 100% 100%;
  }
}
ul{
  padding-left: 0;
  margin: 0 auto;
}
ul li{
  padding-left: 0px;
  list-style: none;
}
a {
  text-decoration: none;
}

a:visited {
  text-decoration: none;
}

a:hover {
  text-decoration: none;
}

a:active {
  text-decoration: none;
}
</style>
